import { authHeader, httpHelper } from '../helpers';
import { post, get } from 'axios';

export const boardService = {
    findByBoard,
    addBoard,
    modBoard,
    delBoard,
    downloadFile,
    findContentsList,
    findContentsListByOffice,
    readBoard,
    checkOpbContent,
    getBoardRecords,
};

function findByBoard(formData) {
    const headers = {headers: authHeader()};
    return post(httpHelper.getApiUrl()+`/board/list/`,formData, headers);
}

function addBoard(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/board/add`, formData, headers);
}

function modBoard(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/board/mod`, formData, headers);
}

function delBoard(boardID) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/board/del/${boardID}`, headers);
}

function downloadFile(kind, boardID, boardFileID) {
    const headers = {headers: authHeader(), responseType: 'arraybuffer'};
    return get(httpHelper.getApiUrl()+`/board/download/${kind}/${boardID}/${boardFileID}`, headers);
}

function findContentsList(formData) {
    const headers = {headers: authHeader()};
    return post(httpHelper.getApiUrl()+`/board/findContentsList/`,formData, headers);
}

function findContentsListByOffice(formData) {
    const headers = {headers: authHeader()};
    return post(httpHelper.getApiUrl()+`/board/findContentsListByOffice/`,formData, headers);
}

function readBoard(boardID) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/board/read/${boardID}`, headers);
}

function checkOpbContent(formData) {
    const headers = {headers: authHeader()};
    return post(httpHelper.getApiUrl()+`/opbcdt/checkOpbContent/`,formData, headers);
}

function getBoardRecords(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/board/getBoardRecords`, formData, headers);
}
